module.exports = __webpack_public_path__ + "img/checked-success.2fd545d4.svg";